import Combobox from "@ls/react-combobox-grid";
import PropTypes from "prop-types";
import React, { memo, useMemo } from "react";
import { calcTypeOptions } from "state/Constants/CalcType";
import { scenarioTypeOptions } from "state/Constants/ScenarioType";
import { Cell, Grid } from "styled-css-grid";
import { useScenarioAnalysisOptionsQuery } from "state/scenarioAnalysis/hooks";
//TOTAL,CURRENCY,SPREAD,YIELD,INCOME,EXCESS,LOCAL
const scenarioAnalysisFactorOptions = [
  { label: "TOTAL", value: "TOTAL" },
  { label: "CURRENCY", value: "CURRENCY" },
  { label: "SPREAD", value: "SPREAD" },
  { label: "YIELD", value: "YIELD" },
  { label: "INCOME", value: "INCOME" },
  { label: "EXCESS", value: "EXCESS" },
  { label: "LOCAL", value: "LOCAL" },
]; //TODO: ask tom how to get these

const ScenarioAnalysisComplication = ({ setDefinition, definition }) => {
  const {
    isFetching: scenarioAnalysisQueryFetching,
    data: scenarioAnalysisQueryData,
  } = useScenarioAnalysisOptionsQuery();
  const scenarioAnalysisOptions =
    scenarioAnalysisQueryData?.scenarioAnalysisOptions;
  const [
    setScenarioAnalysisId,
    setScenarioAnalysisFactor,
    setCalcType,
    setScenarioType,
  ] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setScenarioAnalysisId(value)),
      (value) => setDefinition(definition.setScenarioAnalysisFactor(value)),
      (value) => setDefinition(definition.setCalcType(value)),
      (value) => setDefinition(definition.setScenarioType(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell>
        <Combobox
          label="ScenarioAnalysis:"
          labelPosition="TOP"
          labelKey={"name"}
          valueKey={"id"}
          value={definition.scenarioAnalysisId}
          options={scenarioAnalysisOptions}
          loading={scenarioAnalysisQueryFetching}
          placeholder="Select Scenario Analysis..."
          onChange={setScenarioAnalysisId}
          size={"S"}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Factor:"
          labelPosition="TOP"
          size={"S"}
          value={definition.scenarioAnalysisFactor}
          options={scenarioAnalysisFactorOptions}
          onChange={setScenarioAnalysisFactor}
          gridHeight={100}
          variation={0}
          clearable={false}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Type:"
          size={"S"}
          value={definition.scenarioType}
          options={scenarioTypeOptions}
          onChange={setScenarioType}
          gridHeight={120}
          variation={0}
          clearable={false}
        />
      </Cell>
      <Cell>
        <Combobox
          options={calcTypeOptions}
          onChange={setCalcType}
          value={definition.calcType}
          label="Calc:"
          variation={0}
          size={"S"}
          gridHeight={120}
          clearable={false}
        />
      </Cell>
    </Grid>
  );
};

ScenarioAnalysisComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(ScenarioAnalysisComplication);
